/**
 * FAQ Accordion Functionality
 */
export function initFAQ() {
    
    const faqItems = document.querySelectorAll('.faq-item');
    
    if (!faqItems.length) return;
    
    // Set initial height to 0 for all answers
    faqItems.forEach(function(item) {
        const answer = item.querySelector('.faq-answer');
        if (answer) {
            answer.style.height = '0px';
        }
    });
    
    faqItems.forEach(function(item) {
        const question = item.querySelector('.faq-question');
        const answer = item.querySelector('.faq-answer');
        
        if (!question || !answer) return;
        
        question.addEventListener('click', function(e) {
            e.preventDefault();
            
            const isActive = item.classList.contains('active');
            const answerWrapper = answer.querySelector('.faq-answer-wrapper');
            
            // Close all other FAQ items
            faqItems.forEach(function(otherItem) {
                if (otherItem !== item) {
                    otherItem.classList.remove('active');
                    const otherAnswer = otherItem.querySelector('.faq-answer');
                    if (otherAnswer) {
                        otherAnswer.style.height = '0px';
                    }
                }
            });
            
            // Toggle current item
            if (isActive) {
                item.classList.remove('active');
                answer.style.height = '0px';
            } else {
                item.classList.add('active');
                // Get the actual height of the content
                answer.style.height = 'auto';
                const height = answer.offsetHeight;
                answer.style.height = '0px';
                
                // Trigger reflow
                answer.offsetHeight;
                
                // Set to actual height
                setTimeout(function() {
                    answer.style.height = height + 'px';
                }, 10);
            }
        });
    });
}

